import React from "react";

interface PlatformCardProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  valueColor?: string; // Tailwind color classes
  bgColor?: string; // Tailwind background color classes
}

const PlatformCard: React.FC<PlatformCardProps> = ({
  icon,
  label,
  value,
  valueColor = "text-white",
  bgColor = "bg-white/10",
}) => {
  return (
    <div
      className={`${bgColor} min-w-64 rounded-xl p-6 flex flex-col items-center shadow-md hover:shadow-lg hover:scale-105 transition-transform duration-200`}
    >
      <div className="mb-3 text-5xl">{icon}</div>
      <div className={`text-4xl font-semibold ${valueColor}`}>{value}</div>
      <div className="text-sm text-gray-400 mt-1">{label}</div>
    </div>
  );
};

export default PlatformCard;
